module.exports = __webpack_public_path__ + "img/com.moji.MojiWeatherTest.0000a5d7.png";